module.exports = __webpack_public_path__ + "static/motivation-62ac38e7f6e2ebb36b5f91f3e37fb945.jpg";